import './index.scss';
import React, { PropTypes } from 'react';

const InlineValidationMessage = React.createClass({
    render: function () {
        const { touched, error } = this.props;
        return (
            <div className="inline-validation-message error-message">
                {touched && error && <div>
                  <span className="icon icon--fail"style={{ color: '#c00' }}></span>
                  <span>{error}</span>
                </div>}
            </div>
        );
    }
});

InlineValidationMessage.propTypes = {
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string
};

export default InlineValidationMessage;



// WEBPACK FOOTER //
// ./src/components/common/InlineValidationMessage/index.jsx